__turbopack_context__.v({
  "quote": "quote-module-scss-module__6uUyGG__quote",
  "quoteFormWrp": "quote-module-scss-module__6uUyGG__quoteFormWrp",
  "quoteWrp": "quote-module-scss-module__6uUyGG__quoteWrp",
});
